export default {
  functional: true,

  props: {
    simple: Boolean
  },

  render (h, { props, data, children }) {

    if(props.simple) {
      data.staticClass = data.staticClass ? `marked-text ${data.staticClass} ` : `marked-text `
      return h('span', data, children)
    }
    else {
      data.staticClass = data.staticClass ? `marked-text__wrapper ${data.staticClass} ` : `marked-text__wrapper `
      return h('div', data, [h('span', {staticClass: 'marked-text'}, children)])
    }
  }
}
